import React, { useCallback } from "react";
import useSetTaskCompletion from "../../modules/user/hooks/use-set-task-completion";
import useUser from "../../modules/user/hooks/use-user";

type Props = {
    id: string
}

const TaskCheckbox: React.FC<Props> = ({id}) => {

    const { user } = useUser();

    const isComplated = user?.completedTasks.includes(id);
    const setTask = useSetTaskCompletion();

    const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setTask(id, e.target.checked);
    }, [setTask, id]);

    return <div>
        <label>
            <input onChange={onChange} type="checkbox" defaultChecked={isComplated}  name={id} id={id} />{id}
        </label>
    </div>
}

export default TaskCheckbox;
